module.exports = __webpack_public_path__ + "media/common/images/badges/gray/sprinter-611fb77f9e19fa900e436eaecbdffc45.svg";